<template>
  <RevDrawer name="FLASH_SALES" :title="i18n(translations.modalHeader)">
    <template #body>
      <RevIllustration
        alt=""
        aria-hidden="true"
        class="w-full"
        :height="182"
        :src="imageSrc"
        :width="332"
        @error="setDefaultImage"
      />
      <p class="body-2-bold mt-24">{{ i18n(translations.modalTagline) }}</p>
      <p class="heading-1 mt-4">
        {{ i18n(translations.modalTitle) }}
      </p>
      <p class="body-2 mt-12">
        {{ i18n(translations.modalText, { price: i18n.price(discount) }) }}
      </p>
      <p class="body-2 mt-12">
        {{ i18n(translations.modalDisclaimer) }}
      </p>
    </template>
    <template #footer="{ close }">
      <RevButton full-width="always" variant="primary" @click="close">
        {{ i18n(translations.modalCta) }}
      </RevButton>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './FlashSales.translations'

const i18n = useI18n()

const { categoryId } = defineProps<{
  discount: Price
  categoryId: string
}>()

const imageSrc = ref(i18n(translations.modalImageUrl, { categoryId }))
function setDefaultImage() {
  imageSrc.value = '/img/flash-sales/modal.png'
}
</script>
